module.exports = __webpack_public_path__ + "static/media/how_to_dispose_ja.e66f4e76.png";